import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { faqs } from "./components/FAQ";
import Navbar from "@/components/feature/Navbar";
import DiagnosticVideo from "@/components/feature/DiagnosticVideo";
import Footer from "@/components/feature/Footer";
import FloatingButton from "@/components/feature/FloatingButton";
import Avis from "@/components/feature/Avis";
import Hero from "./components/Hero";
import Reassurances from "./components/Reassurances";
import SangleCasse from "./components/SangleCasse";
import RemplacementSangle from "./components/RemplacementSangle";
import EnrouleurGuidage from "./components/EnrouleurGuidage";
import ReparerPlutot from "./components/ReparerPlutot";
import CTAAppel from "./components/CTAAppel";
import FAQ from "./components/FAQ";
import Galerie from "./components/Galerie";
import Maillage from "./components/Maillage";
import Formulaire from "./components/Formulaire";

export default function SangleVoletRoulantPage() {
  return (
    <div className="font-sans">
      <SEOHead
        title="Sangle Volet Roulant Strasbourg | Remplacement Toutes Marques"
        description="Remplacement de sangle et cordon de volet roulant à Strasbourg et dans le Bas-Rhin. Toutes dimensions, toutes marques, devis gratuit. 03 74 47 32 40."
        path="/sangle-volet-roulant"
        type="service"
        serviceType="Remplacement de sangle de volet roulant"
        faqs={faqs}
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Sangle volet roulant" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Sangle volet roulant" }]} />
      <main>
        <Hero />
        <DiagnosticVideo />
        <Reassurances />
        <SangleCasse />
        <RemplacementSangle />
        <EnrouleurGuidage />
        <ReparerPlutot />
        <CTAAppel />
        <FAQ />
        <Galerie />
        <Maillage />
        <Formulaire />
        <CTAAppel />
        <Avis />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}